import React from 'react';
import { CollapsingContainer } from '../app-listing/collapsing-container';
import { get, isNull, isUndefined, map, isEmpty } from 'lodash';
import { hasItem, productionQuestions } from '../app-production-questions/data/utils';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const ProductionRulesSection = ({ faqFn, faqData }) => {
  const faqKeys = Object.keys(faqFn());
  return (
    <div data-testing-id="production-rules-section">
      {
        map(faqKeys, (key) => {
          const answer = get(faqData, key);
          const faqHash = faqFn(answer);
          const label = get(faqHash, [key, 'label'], '');
          const description = get(faqHash, [key, 'description'], '');

          if (isUndefined(answer) || isNull(answer) || '' === answer) {
            return null;
          }

          // zeros are acceptable answers
          if (!label && !description) {
            return null;
          }

          return (
            <div key={key}>
              { label && <div className="heavier margin-xl-top">{label}</div> }
              { description && <div className="text-gray-600">{description}</div> }
            </div>
          );
        })
      }
    </div>
  );
};

const HostRulesAgree = ({ hostRulesData, displayRulesOnly, intl }) => {
  const {
    listingRules,
    surveillanceData
  } = hostRulesData;

  const missingSurveillanceInfo = isEmpty(surveillanceData);
  const surveillanceDescription = get(surveillanceData, 'description', '');
  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';
  return (
    <div className="flex" data-testing-id="host-rules-agree">
      <div className="margin-xl-bottom">
        { !displayRulesOnly &&
          <div data-testing-id="rules-description">
            <div className="flex middle h6 no-top-margin">
              <img
                className="icon margin-md-right"
                src="/web-2/assets/images/rules.svg?v=rb"
                alt={ intl.formatMessage({ id: 'invite.host_rules_agree.rules_icon', defaultMessage: 'Rules Icon' }) }
              />
              <span>
                <FormattedMessage id="invite.host_rules_agree.host_rules" defaultMessage='Host Rules' />
              </span>
            </div>
            <p className="text-base text-gray-600">
              <FormattedMessage id="invite.host_rules_agree.accept_rules" defaultMessage='You must review and accept the host’s rules and disclosures to book the space.' />
            </p>
          </div>
        }

        <div style={{ padding: '16px' }} className="border-gray-200 rounded-border">
          <CollapsingContainer
            collapsedHeight={displayRulesOnly ? 126 : 104}
            showText={ intl.formatMessage({ id: 'invite.host_rules_agree.read_more', defaultMessage: 'Read more' }) }
            hideText={ intl.formatMessage({ id: 'invite.host_rules_agree.hide', defaultMessage: 'Hide' }) }
            animated={false}
            className="rules-container"
            hasFade={!displayRulesOnly}
          >

            <div className="margin-lg-bottom">
              <div className="heavier">
                <FormattedMessage id="invite.host_rules_agree.rules" defaultMessage='General Rules' />
              </div>
              <p className="text-gray-600" style={{ whiteSpace: 'pre-wrap' }} data-testing-id="rules">{listingRules}</p>
            </div>

            {
              hasItem(Object.keys(productionQuestions.rules.faq()), hostRulesData) &&
                <ProductionRulesSection
                  faqFn={productionQuestions.rules.faq}
                  faqData={hostRulesData}
                />
            }

            { (surveillanceDescription || missingSurveillanceInfo) &&
              <div className="margin-lg-top margin-lg-bottom" data-testing-id="surveillance-description-container">
                <div className="heavy">
                  <FormattedMessage id="invite.host_rules_agree.security_and_recording" defaultMessage='Security cameras and recording devices' />
                </div>
                <p className="text-gray-600" style={{ whiteSpace: 'pre-wrap' }} data-testing-id="surveillance-description">
                  {
                    surveillanceDescription ||
                    <FormattedMessage id="invite.host_rules_agree.check_host" defaultMessage='Check with your host if there are any surveillance cameras or recording devices in the space.' />
                  }
                </p>
                <p className="text-gray-600">
                  <FormattedMessage
                    id="invite.host_rules_agree.recording_bathrooms"
                    defaultMessage='Recording devices in bathrooms or dressing rooms are prohibited by the {terms}.'
                    values={{
                      terms: (
                        <a href={`${urlPrefix}/legal/terms`} target="_blank">
                          <FormattedMessage id="invite.host_rules_agree.peerspace_agreement" defaultMessage='Peerspace Services Agreement' />
                        </a>
                      )
                    }}
                  />
                </p>
              </div>
            }

          </CollapsingContainer>
        </div>
      </div>
    </div>
  );
};


export default injectIntl(HostRulesAgree);
